package com.loyola.acessoescola.ui.components

import acessoescola.composeapp.generated.resources.Res
import acessoescola.composeapp.generated.resources.database_error
import acessoescola.composeapp.generated.resources.error
import acessoescola.composeapp.generated.resources.error_24px
import acessoescola.composeapp.generated.resources.ok
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Button
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import org.jetbrains.compose.resources.stringResource
import org.jetbrains.compose.resources.vectorResource

@Composable
fun ErrorDialog(
    errorMessage: String,
    onErrorMessageChange: (String) -> Unit
){
    AlertDialog(
        onDismissRequest = { onErrorMessageChange("") },
        confirmButton = { Button(onClick = { onErrorMessageChange("") }){ Text(stringResource(Res.string.ok))} },
        icon = {Icon(imageVector = vectorResource(Res.drawable.error_24px), contentDescription = stringResource(Res.string.error))},
        title = {Text(text = stringResource(Res.string.database_error))},
        text = {Text(text = errorMessage)}
    )
}